export default {
    YES: "Да",
    NO: "Нет"
};
